// @flow
import React, { Fragment } from "react";
import { withGlobalContext } from "../common/GlobalContext";
import withStyles from "elevate-ui/withStyles";

import type {
  $SiteOffice,
  $Agent,
  ComplianceItems as $ComplianceItems,
} from "flow/types";

type $Props = {
  classes: Object,
  office: $SiteOffice,
  agent: $Agent,
  compliance: $ComplianceItems,
};

const renderStickyHeader = (mobile, office, agent) => {
  if (
    mobile &&
    office &&
    office.name &&
    agent &&
    agent.firstName &&
    agent.lastName
  ) {
    return (
      <div className={"ref__mls-header-compliance"}>{`${office.name}, ${
        agent.firstName
      } ${agent.lastName}`}</div>
    );
  }
  if (office && office.name) {
    return <div className={"ref__mls-header-compliance"}>{office.name}</div>;
  } else {
    return null;
  }
};

const StickyHeader = ({
  classes,
  office,
  agent,
  compliance: { stickyHeaderCustom, stickyHeader, stickyHeaderMobile },
}: $Props) => {
  return (
    <Fragment>
      <div className={classes.stickyHeader}>
        {stickyHeaderCustom && (
          <div
            className={"ref__mls-header-compliance"}
            dangerouslySetInnerHTML={{
              __html: stickyHeaderCustom,
            }}
          />
        )}
        {(stickyHeader || stickyHeaderMobile) &&
          renderStickyHeader(stickyHeaderMobile, office, agent)}
      </div>
    </Fragment>
  );
};

const styles = (theme) => {
  return {
    stickyHeader: {
      paddingTop: theme.spacing.unit * 0.5,
      paddingBottom: theme.spacing.unit * 0.5,
      textAlign: "center",
      position: "fixed",
      width: "100%",
      top: 0,
      zIndex: theme.zIndex.stickyHeader,
      backgroundColor: theme.colors.primary["500"],
      color: theme.colors.primaryFontColor,
      "& a": {
        color: "inherit",
      },
    },
  };
};

export default withGlobalContext(withStyles(styles)(StickyHeader));
